import React from "react";
import { LocalKnobNumberInput } from "./LocalKnobNumberInput";

function SegmentButton({ active, onClick, children, disabled }) {
  return (
    <button
      type="button"
      className={[
        "ai-chat-local-segment-btn",
        active ? "ai-chat-local-segment-btn--active" : "",
      ].join(" ")}
      onClick={() => {
        if (disabled) return;
        onClick?.();
      }}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function LocalContextAllocationControl({
  mode,
  size,
  onModeChange,
  onSizeChange,
  onSizeBlur,
  isBusy,
}) {
  const isManual = mode === "manual";

  return (
    <div className="ai-chat-local-knob ai-chat-local-knob--allocation">
      <div className="ai-chat-local-knob-label">Allocation</div>

      <div className="ai-chat-local-knob-bottom">
        <div className="ai-chat-local-segmented">
          <SegmentButton
            active={mode === "auto"}
            onClick={() => onModeChange?.("auto")}
            disabled={isBusy}
          >
            Auto
          </SegmentButton>
          <SegmentButton
            active={mode === "manual"}
            onClick={() => onModeChange?.("manual")}
            disabled={isBusy}
          >
            Manual
          </SegmentButton>
        </div>

        <div
          className={[
            "ai-chat-local-manual-inputs",
            "ai-chat-local-manual-inputs--single",
            isManual ? "" : "ai-chat-local-manual-inputs--hidden",
          ].join(" ")}
        >
          <LocalKnobNumberInput
            value={size}
            onChange={onSizeChange}
            onBlur={onSizeBlur}
            disabled={!isManual || isBusy}
            min={256}
            max={128000}
            step={256}
            title="Context allocation size (tokens)"
            placeholder="Size"
            tabIndex={isManual ? 0 : -1}
            className="ai-chat-local-knob-number--single"
          />
        </div>
      </div>
    </div>
  );
}

